import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Tab, Tabs, Button, Dropdown } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear, faMoneyBillTransfer, faReceipt } from '@fortawesome/free-solid-svg-icons';

import Cargoplane from "../../../../assets/images/plane.svg";
import Arcv from "../../../../assets/images/archive.svg";
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";

import { Link } from 'react-router-dom';
import Badge from 'react-bootstrap/Badge';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import Rapdf from "../../../../assets/images/pdf.png";
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { ULDONLOANGRID, MVTONLOAN, FINALIZETR, GETULDDETAILS, MVTHDETAILS, EDITPTRANSFER, MOVETOACTARC } from '../../../../Utils/conts.js';
import DownloadGrid from '../components/DownloadGrid.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const Messages = () => {
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [totalLoan, setTotalLoan] = useState({});
    const [totalPending, setTotalPending] = useState({});
    const [gridData, setGridData] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [activeTab, setActiveTab] = useState('Loan');
    const fetchDataGridL = async () => {
        const tabName = activeTab == 'Loan' ? 'L' : 'T';
        setIsLoading(true);
        try {
            const res = await withRFSToken.post(ULDONLOANGRID, { type: tabName })
                .then(function (res) {
                    const innerData = res.data.response_data.loan_data;
                    setIsLoading(false);
                    if (activeTab == 'Loan') {
                        setGridData({ Loan: innerData });
                    } else {
                        setGridData({ Transfer: innerData });
                    }

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    // const fetchDataGridT = async () => {
    //     try {
    //         const res = await withRFSToken.post(ULDONLOANGRID, { type: 'T' })
    //             .then(function (res) {
    //                 const innerData = res.data.response_data.loan_data;
    //                 console.log('inn', innerData);
    //                 setGridData({ Transfer: innerData });
    //             });
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGridL();
        setIsLoading(false);
        setGridData({});
        // fetchDataGridT();
        isMounted.current = true;
    }, [])
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);

    const [isFinalize, setIsFinalize] = useState(false);
    const [action, setAction] = useState();
    const [finalizeData, setFinalizeData] = useState('');
    const gridRef = useRef(null);
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        setIsLoading(true);
        setFilterApplied(false);
        setSelectedRowData();
        if (tab == 'Loan') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Loan: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Transfer: {} });
            }, 1);
        }


    };
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {

        if (gridRef.current) {
            // if (gridData[activeTab]) {

            const pageSize = 20;
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            let tabType = '';
            if (activeTab == 'Loan') { tabType = 'L' } else { tabType = 'T' }
            const source = {

                datatype: 'json',

                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'movement_type', type: 'string' },
                    { name: 'processed_on', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'type_code', type: 'string' },
                    { name: 'control_receipt_number', type: 'string' },
                    
                    { name: 'messages', type: 'string' },
                    { name: 'emails', type: 'string' },
                ],
                id: `${activeTab}`,
                url: `${process.env.REACT_APP_RFS_URL}handler-luc/message-list`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },

                pagesize: 50,
                filter: function (allfilters) {
                    // window.$(gridRef.current).jqxGrid('clearselection');
                    // setGridSelect([]);

                    // if (allfilters.length > 0) {
                    //     console.log("Filter Applied");
                    //     setFilterApplied(true);
                    // } else {
                    //     console.log("Filter Cleared");
                    //     setFilterApplied(false);
                    // }
                    // window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRef.current).jqxGrid('getrows');

                    //     console.log("rows",rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);                            
                    //         rows.forEach((element,index) => {
                    //             if(element.uld_number==uldNumber){
                    //                 window.$(gridRef.current).jqxGrid('selectrow', index);
                    //             }
                    //         });                            
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    let loanCount = 0;
                    let pendingCount = 0;
                    if (data) {
                        loanCount = data.lcount;
                        pendingCount = data.ocount;
                    }
                    setTotalLoan({ totalUlds: loanCount });
                    setTotalPending({ totalUlds: pendingCount });
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            // console.log('localdata', source.localdata)
            const columns = [
                { text: 'Movement Type', filtertype: 'textbox', datafield: 'movement_type', width: '8%', cellclassname: '', },
                { text: 'Processed On', filtertype: 'textbox', datafield: 'processed_on', width: '10%', cellclassname: '', },
                { text: 'Airline', filtertype: 'textbox', datafield: 'owner_code', width: '8%', cellclassname: '', },
                { text: 'Control Receipt No.', filtertype: 'textbox', datafield: 'control_receipt_number', width: '8%', cellclassname: '', },
            ];

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: 'none',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                // pagerrenderer: pagerRenderer,
                rendergridrows: function (params) {
                    return params.data;
                },

            };

            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            // window.$(gridRef?.current).on('bindingcomplete', function () {
            //     window.$(gridRef?.current).jqxGrid({ pagesizeoptions: ['20', '50', '100', '200', '500'] });
            // });

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
        }
        window.$(gridRef.current).off('cellclick');

        window.$(gridRef.current).on('cellclick', (event) => {
            const args = event.args.row.bounddata;
             setSelectedRowData(args);
            // if (event.args.columnindex > 0) {
                
            // }
        });
    }, [gridData]);

    const handleModalOpen = (pos) => {
        setAction(pos);
        setIsFinalize(true);
    };

    const onLoanEdit = async (batch) => {
        try {
            const res = await withRFSToken.post(EDITPTRANSFER, { batch_no: batch })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ innerData:", innerData)

                    const storageData = {
                        "ULD": innerData.ULD,  // ULD Details section
                        "Form": innerData.Form,  // Empty form section
                        "Edit": innerData.go_to
                    };
                    localStorage.setItem(innerData.go_to, JSON.stringify(storageData));
                    localStorage.setItem('HULDtab', 'onloan');
                    const fnPageUrl = '/ULDControl/ULDFunction';  // ${itemId} Change "/details/" to the actual path of your details page
                    // Navigate to the details page
                    window.location.href = fnPageUrl;
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const loadDetails = async (uldNumber) => {
        try {
            const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setSelectedRowData(innerData);
                    setTimeout(() => {
                        window.$(gridRef.current).jqxGrid('refresh');
                    }, 30);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    // +++++++++++++++++++++++++++++++++++++++++++++++++++++ file upload 

    const resetFilters = () => {
        window.$(gridRef.current).jqxGrid('clearfilters');
    };

    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRef.current).jqxGrid('refresh');
        }, 30);
    };


    return (
        <>
            {/* <div className="mb-3 nestedtabs rounded minh"> */}
            {/* <div className='d-flex'> */}
            {/* <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                            <FontAwesomeIcon icon={faPlus} /> Add ULD <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                            <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'LUC In')}>LUC In</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'LUC In')}>Report Damage</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'LUC In')}>Report Missing</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
            {/* <button className="transfer" variant="link" onClick={() => handleDropdownItemClick('top', 'Transfer')}>
                        <span> <FontAwesomeIcon icon={faMoneyBillTransfer} /> Station Transfer</span>
                    </button>
                    <button className="receive" variant="link" onClick={() => handleDropdownItemClick('top', 'Request')}>
                        <span> <FontAwesomeIcon icon={faReceipt} /> Transfer Request</span>
                    </button> */}
            {/* <span className="selected">
                        Selected ULD <Badge>{gridSelect.length}</Badge>
                    </span> */}
            {/* </div> */}
            {/* </div> */}

            {/* <div className='ulddown'>
                <button onClick={handleMoveToActArc}><img src={Arcv} /> Archive</button>
                <button onClick={showDownloadModal}><img src={Export} /> Download</button>
            </div> */}

            <div className="maindiv">
                <div className='trashdonload'>
                    {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                </div>
                {selectedRowData && (
                    <div className='SecondDiv uld_msg'>
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className="girddtals_header">
                            <h3>Email ID's</h3>
                        </div>
                        <div>
                            {/* <p dangerouslySetInnerHTML={{ __html: selectedRowData.messages }}></p> */}
                            <p style={{ whiteSpace: 'pre-line' }}>{selectedRowData.emails}</p>
                        </div>
                        <div className="girddtals_header">
                            <h3>Message</h3>
                        </div>
                        <div>
                            <p dangerouslySetInnerHTML={{ __html: selectedRowData.messages }}></p>
                            {/* <p style={{ whiteSpace: 'pre-line' }}>{selectedRowData}</p> */}
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default Messages